import styled from "styled-components";

interface FieldErrorProps {
  hidden?: boolean;
}

export const FieldError = styled.div.attrs({ role: "alert" })<FieldErrorProps>`
  color: ${({ theme }) => theme.global.error_color};
  position: absolute;
  top: ${({ theme }) => theme.forms.field_height}px;
  font-size: 12px;

  ${({ hidden }) =>
    hidden &&
    `
    display: none;
  `}
`;
